// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2437":"ba888fe0","66198":"ac7bb609","66447":"74624d5f","74059":"6953f8a3"}[chunkId] + ".chunk.css";
};